import * as constants from "../../Constants";
import * as BooksAPI from "../../BooksAPI";
import { showLoading, hideLoading } from "react-redux-loading";
export const setAllShelfs = (books) => {
  return {
    type: constants.setAllShelfs,
    payload: books,
  };
};

export const moveBookToShelf = (book) => {
  return {
    type: constants.moveBookToShelf,
    payload: book,
  };
};

export const getInitialBooks = () => {
  return (dispatch, getState) => {
    if (getState().bookReducer.books.length > 0) return;
    dispatch(showLoading());
    BooksAPI.getAll()
      .then((data) => {
        dispatch(hideLoading());
        if (data.length === 0) return;
        const books = data.sort((a, b) => (a.title > b.title ? 1 : -1));

        dispatch({
          type: constants.getInitialBooks,
          payload: books,
        });
      })
      .catch(() => {
        dispatch(hideLoading());
        alert("There was an error. Try again");
      });
  };
};

export const setShelf = (book) => {
  return (dispatch, getState) => {
    const books = [...getState().bookReducer.books];
    const [prevBook] = books.filter((_book) => _book.id === book.id);
    const _prevBook = { ...prevBook }; // or we can use : JSON.parse(JSON.stringify(prevBook));
    dispatch(showLoading());
    let result = moveBookToShelf(book);
    dispatch(result);
    BooksAPI.update(book, book.shelf)
      .then(() => {
        dispatch(hideLoading());
      })
      .catch(() => {
        result = moveBookToShelf(_prevBook);
        dispatch(result);
        dispatch(hideLoading());
        alert("There was an error. Try again");
      });
  };
};
